import * as angular from 'angular';
import * as api from 'shared/childupp-api';
import * as dom from './dom';
import { preloadImage, preloadStyesheet } from './preload'

/**
 * Returns a promise that resovles after the custom content for the currently
 * running childupp has been injected into the engine context.
 *
 * @return {Promise.<void>}
 */
export async function loadChilduppCustomContent() {
    const loadCustomCss = () => {
        return api.getCustomCss().then((css) => {
            const elem = dom.createStyleElement({ id: 'childupp-custom-css' });
            const appendedElem = document.head.appendChild(elem);
            appendedElem.innerHTML = css;
            return Promise.resolve(appendedElem);
        })
    };

    const loadCustomJs = () => {
        return api.getCustomJs().then((js) => {
            const elem = dom.createScriptElement({ id: 'childupp-custom-javascript' });
            const appendedElem = document.body.appendChild(elem);
            appendedElem.innerHTML = js;
            return Promise.resolve(appendedElem);
        })
    };

    await Promise.all([
        loadCustomCss(),
        loadCustomJs(),
    ])
    return Promise.resolve();
}

/**
 * Returns a promise that resolves after assets related with the childupp
 * are loaded (and probably cached) by the browser, allowing them to be
 * loaded faster later.
 *
 * @return {Promise<void>}
 */
export async function preloadChilduppAssets() {
    const {
        templatePath,
        backgroundURL,
        logoPath,
    } = await api.getConfig();

    const preloadTemplate = (templatePath) => {
        // FIXME: Preload stylesheet returns the element used, by adding it to
        // the body, we prevent the FOUC that happens between the preload and
        // the application template load. This SHOULD BE REMOVED once that is
        // fixed on the application side.
        return preloadStyesheet(templatePath)
        .then((stylesheetElem) => {
            stylesheetElem.setAttribute('id', 'templateCss');
            return document.head.appendChild(stylesheetElem);
        });
    };

    return Promise.all([
        backgroundURL ? preloadImage(backgroundURL) : Promise.resolve(),
        logoPath ? preloadImage(logoPath) : Promise.resolve(),
        templatePath ? preloadTemplate(templatePath) : Promise.resolve(),
    ]);
}


/**
 * Bootstraps the given angular module and returns a promise that is resolved
 * after the angular application has started running.@async
 *
 * @param  {ng.IModule} module
 * @return {Promise<void>}
 */
export function bootstrapAngularApp(module) {
    return new Promise((resolve) => {
        // Add promise resolution as a run step of the angular application
        module.run(() => resolve());
        // Actually leverage angular application
        angular.element(document).ready(() => {
           angular.bootstrap(document, [ module.name ]);
        });
    })
}



// WEBPACK FOOTER //
// ./src/shared/childupp-bootstrap/index.js